/**
 * What the universal-ai block knows about the page it renders on, for the
 * shared building blocks a component uses (StageIntro, …): the demo switch
 * and the editor's stage intros. The block's view.js provides it, so a
 * component never threads these through its own props — a component copied
 * from `_skeleton` gets them for free.
 */
import React, { useContext } from "react";

export const BlockContext = React.createContext({ mockupMode: false, intros: [] });

export const useBlockContext = () => useContext(BlockContext);
